import { buildThemeAssetUrl, themeSpriteBasename } from "./themeAssets";

export function parseFiniteNumber(value, fallback) {
  const num = Number(value);
  return Number.isFinite(num) ? num : fallback;
}

/**
 * Normalize theme `good` / `bad` entries: objects with bug_gif (preferred) or legacy strings.
 */
export function normalizeBugCatalog(themeData) {
  const td = themeData || {};
  const goodPenalty = Math.abs(parseFiniteNumber(td.Negative_points, 5));
  const badReward = Math.abs(parseFiniteNumber(td.points, 10));

  const normalizeBugType = (v) => {
    const raw = String(v ?? "").trim().toLowerCase();
    if (!raw) return "flying";
    if (raw.startsWith("walk") || raw.startsWith("crawl") || raw.includes("rept")) return "walking";
    if (raw.startsWith("fly")) return "flying";
    return raw === "walking" ? "walking" : "flying";
  };

  const mapEntry = (entry, kind, idx) => {
    const isGood = kind === "good";
    if (typeof entry === "string") {
      const s = entry.trim();
      if (!s) return null;
      return {
        kind,
        typeKey: `${kind}-legacy-${idx}-${themeSpriteBasename(s)}`,
        bugGif: s,
        deathImage: "",
        bugType: "flying",
        points: isGood ? -goodPenalty : badReward,
        speed: isGood ? 2.2 : 3.2,
        spawnRate: 1,
      };
    }
    if (!entry || typeof entry !== "object") return null;
    const bugGif = String(entry.bug_gif ?? entry.bugGif ?? "").trim();
    if (!bugGif) return null;
    const deathImage = String(entry.death_image ?? entry.deathImage ?? "").trim();
    const bugType = normalizeBugType(entry.bug_type ?? entry.bugType ?? entry.type);
    const pointsRaw = entry.points;
    const points = Number.isFinite(Number(pointsRaw))
      ? Number(pointsRaw)
      : isGood
        ? -goodPenalty
        : badReward;
    const speed = Math.max(0.15, parseFiniteNumber(entry.speed, isGood ? 2.2 : 3.2));
    const spawnRate = Math.max(0.05, parseFiniteNumber(entry.spawn_rate ?? entry.spawnRate, 1));
    const baseName = themeSpriteBasename(bugGif);
    return {
      kind,
      typeKey: `${kind}-${idx}-${baseName}`,
      bugGif,
      deathImage,
      bugType,
      points,
      speed,
      spawnRate,
    };
  };

  const goodRaw = Array.isArray(td.good) ? td.good : [];
  const badRaw = Array.isArray(td.bad) ? td.bad : [];

  const good = goodRaw.map((e, i) => mapEntry(e, "good", i)).filter(Boolean);
  const bad = badRaw.map((e, i) => mapEntry(e, "bad", i)).filter(Boolean);

  return { good, bad, all: [...good, ...bad] };
}

export function resolveBugAssetUrl(asset) {
  return buildThemeAssetUrl(String(asset || "").trim());
}

/** Weighted random index into `items` using each item's spawnRate. */
export function pickWeightedBug(rng, items) {
  if (!items.length) return null;
  let sum = 0;
  for (const it of items) sum += Math.max(0.0001, it.spawnRate);
  let r = rng() * sum;
  for (let i = 0; i < items.length; i += 1) {
    r -= Math.max(0.0001, items[i].spawnRate);
    if (r <= 0) return items[i];
  }
  return items[items.length - 1];
}
